module.exports = __webpack_public_path__ + "static/media/background.5c04170a.png";